module.exports = __webpack_public_path__ + "static/media/institutions-1.920523cc.png";